// extracted by mini-css-extract-plugin
export var resizer = "_h9-0";